import { i18n } from '@lingui/core';
import { Affix } from '@warp-ds/react';
import { TextField } from '@warp-ds/react';
import React from 'react';

type SearchProps = {
    onSearch: (searchQuery: string) => void;
    initialFocusRef: any;
};

const Search: React.FC<SearchProps> = ({ onSearch, initialFocusRef }) => (
    <TextField
        ref={initialFocusRef}
        label={i18n.t({ id: 'searchLabel' })}
        type="search"
        placeholder={i18n.t({
            id: 'searchPlaceholder',
        })}
        onChange={(event) => onSearch(event.target.value)}
    >
        <Affix
            suffix
            search
            onClick={() => onSearch(initialFocusRef.textfield.value)}
        />
    </TextField>
);

export default Search;
